// extracted by mini-css-extract-plugin
export var card = "_48-0";
export var content = "_48-1";
export var contentLoading = "_48-2";